import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { materialSymbols } from '../../../../../../shared/constants/material-symbols';
import { ToastService } from '../../../../../../shared/services/toast.service';
import { FinaliseSrsBallotRequest } from '../../../../shared/models/sr/finalise-srs-ballot-request';
import { SrsBallotReviewOutcome } from '../../../../shared/models/sr/srs-ballot-review-outcome';
import { SrsBallotReviewStage } from '../../../../shared/models/sr/srs-ballot-review-stage';
import { SrsBallotService } from '../../../../shared/services/srs-ballot.service';


@Component({
    selector: 'app-srs-review-modal',
    templateUrl: './srs-review-modal.component.html',
    styleUrl: './srs-review-modal.component.scss',
    standalone: false
})
export class SrsReviewModalComponent implements OnInit {
  @Input() modalTitle: string = '';
  @Input() modalMessage: string = '';

  @Input() ballotId?: string;
  @Input() resolutionId?: string;
  @Input() reviewStageId?: SrsBallotReviewStage;
  @Input() reviewOutcomeId?: SrsBallotReviewOutcome
  @Input() requireComments: boolean = false;
  @Input() isYesNoButtons: boolean = false;

  comment?: string;
  isValidInputs: boolean = false;

  closeIcon = materialSymbols.close;
  modalIcon: string = '';
  modalIconColor: string = '';

  submitButtonText: string = 'Submit';
  cancelButtonText: string = 'Cancel';

  subscriptions: Subscription = new Subscription();

  reviewForm: FormGroup = new FormGroup({
    commentCtrl: new FormControl(null),
  });

  get commentCtrl() {
    return this.reviewForm.get('commentCtrl') as FormControl;
  }

  constructor(
    private _activeModal: NgbActiveModal,
    private _toastService: ToastService,
    private _srsBallotService: SrsBallotService
  ) {}

  ngOnInit(): void {
    // All inputs are required
    this.isValidInputs =
      !!(this.ballotId && this.resolutionId && this.reviewStageId && this.reviewOutcomeId);

    this.modalIcon = this.reviewOutcomeId === SrsBallotReviewOutcome.Reject ? materialSymbols.cancel : materialSymbols.checkCircle;
    this.modalIconColor = this.reviewOutcomeId === SrsBallotReviewOutcome.Reject ? 'text-red-500' : 'text-green-500';

    if (this.requireComments) {
      this.commentCtrl.setValidators([Validators.required]);
      this.commentCtrl.updateValueAndValidity();
    }

    this.submitButtonText = this.isYesNoButtons ? 'Yes' : 'Submit';
    this.cancelButtonText = this.isYesNoButtons ? 'No' : 'Cancel';
  }

  onSubmit(): void {

    if (!this.isValidInputs) {
      console.error('SrsReviewModalComponent: Missing required inputs.');
      return;
    }

    const request: FinaliseSrsBallotRequest = {
      ballotId: this.ballotId as string,
      resolutionId: this.resolutionId as string,
      comment: this.commentCtrl.value || null,
      reviewStageId: this.reviewStageId as SrsBallotReviewStage,
      reviewOutcomeId: this.reviewOutcomeId as SrsBallotReviewOutcome,
    };

    this.subscriptions.add(
      this._srsBallotService.finaliseSrsBallot(request)
      .subscribe({
        next: (response) => {
          if (response && response.success) {
            this._toastService.showSuccess('SRS Ballot review submitted successfully.');
            this._activeModal.close(request.ballotId);
          }
          else {
            this._toastService.showError('Failed to submit SRS Ballot review. Please try again later.');
            this._activeModal.close(request.ballotId);
          }
        },
        error: (error) => {
          this._toastService.showError('An error occurred while submitting SRS Ballot review. Please try again later.');
          this._activeModal.close(request.ballotId);
        }
      })
    );
  }

  cancel(): void {
    this._activeModal.dismiss();
  }

}
